function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar, Label, Input, Modal, ModalBody, ModalFooter, ModalHeader } from '@appfolio/react-gears';
import classnames from 'classnames';

var FeedbackModal = /*#__PURE__*/function (_Component) {
  _inherits(FeedbackModal, _Component);

  var _super = _createSuper(FeedbackModal);

  function FeedbackModal(props) {
    var _this;

    _classCallCheck(this, FeedbackModal);

    _this = _super.call(this, props);

    _this.onCancel = function () {
      _this.props.onCancel();

      _this.setState({
        rating: null,
        comment: null
      });
    };

    _this.onSubmit = function () {
      var rating = _this.state.rating;
      var comment = _this.state.comment;
      var error = false;
      var commentErrorMessage = null;
      var ratingErrorMessage = null;

      if (!rating && _this.props.ratingRequired) {
        ratingErrorMessage = 'can\'t be blank';
        error = true;
      }

      if (!comment && _this.props.commentRequired) {
        commentErrorMessage = 'can\'t be blank';
        error = true;
      }

      _this.setState({
        commentValidationError: commentErrorMessage,
        ratingValidationError: ratingErrorMessage
      });

      if (error) {
        return;
      }

      _this.setState({
        submitting: true
      });

      _this.props.onSubmit({
        rating: rating,
        comment: comment
      });
    };

    _this.state = {
      ratingValidationError: null,
      commentValidationError: null,
      submitting: false,
      rating: null,
      comment: null
    };
    return _this;
  }

  _createClass(FeedbackModal, [{
    key: "renderRating",
    value: function renderRating() {
      var _this2 = this;

      var _this$props = this.props,
          highRatingText = _this$props.highRatingText,
          lowRatingText = _this$props.lowRatingText;
      return /*#__PURE__*/React.createElement("div", {
        className: "js-ratings"
      }, /*#__PURE__*/React.createElement("div", {
        className: "mb-5"
      }, /*#__PURE__*/React.createElement("div", {
        className: "d-flex mb-2 mx-3 justify-content-between"
      }, /*#__PURE__*/React.createElement("span", {
        className: "js-low-rating-text font-italic"
      }, lowRatingText), /*#__PURE__*/React.createElement("span", {
        className: "js-high-rating-text font-italic"
      }, highRatingText)), /*#__PURE__*/React.createElement("div", {
        className: "d-flex justify-content-around mb-2"
      }, [1, 2, 3, 4, 5].map(function (rating) {
        return /*#__PURE__*/React.createElement("div", {
          key: "rating-".concat(rating)
        }, /*#__PURE__*/React.createElement("div", null, rating), /*#__PURE__*/React.createElement(Input, {
          className: "ml-auto mt-2",
          type: "radio",
          name: "rating",
          "data-value": rating,
          onClick: function onClick() {
            return _this2.setState({
              rating: rating
            });
          }
        }));
      }))), /*#__PURE__*/React.createElement("span", {
        className: "text-danger"
      }, this.state.ratingValidationError));
    }
  }, {
    key: "renderSubtitle",
    value: function renderSubtitle(included, required, text, type) {
      var result;

      if (included) {
        var labelClass = "mb-2 font-weight-bold js-".concat(type, "-subtitle ").concat(classnames({
          'text-danger': this.state["".concat(type, "ValidationError")]
        }));
        result = /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Label, null, /*#__PURE__*/React.createElement("span", {
          className: labelClass
        }, text, required && /*#__PURE__*/React.createElement("span", {
          className: "text-danger pl-1"
        }, "*"))));
      }

      return result;
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      var _this3 = this;

      var _this$props2 = this.props,
          commentIncluded = _this$props2.commentIncluded,
          commentPlaceholder = _this$props2.commentPlaceholder,
          commentRequired = _this$props2.commentRequired,
          commentSubtitle = _this$props2.commentSubtitle,
          ratingIncluded = _this$props2.ratingIncluded,
          ratingRequired = _this$props2.ratingRequired,
          ratingSubtitle = _this$props2.ratingSubtitle;
      return /*#__PURE__*/React.createElement("div", null, this.renderSubtitle(ratingIncluded, ratingRequired, ratingSubtitle, 'rating'), ratingIncluded && this.renderRating(), this.renderSubtitle(commentIncluded, commentRequired, commentSubtitle, 'comment'), commentIncluded && /*#__PURE__*/React.createElement(Input, {
        className: "js-comment",
        placeholder: commentPlaceholder,
        rows: 5,
        type: "textarea",
        onChange: function onChange(e) {
          return _this3.setState({
            comment: e.target.value
          });
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger"
      }, this.state.commentValidationError));
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.isOpen && !nextProps.isOpen) {
        this.setState({
          ratingValidationError: null,
          commentValidationError: null,
          submitting: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          isOpen = _this$props3.isOpen,
          modalTitle = _this$props3.modalTitle,
          commentIncluded = _this$props3.commentIncluded,
          commentPlaceholder = _this$props3.commentPlaceholder,
          commentRequired = _this$props3.commentRequired,
          commentSubtitle = _this$props3.commentSubtitle,
          highRatingText = _this$props3.highRatingText,
          lowRatingText = _this$props3.lowRatingText,
          onCancel = _this$props3.onCancel,
          onSubmit = _this$props3.onSubmit,
          ratingIncluded = _this$props3.ratingIncluded,
          ratingRequired = _this$props3.ratingRequired,
          ratingSubtitle = _this$props3.ratingSubtitle,
          cancelButtonText = _this$props3.cancelButtonText,
          pleaseWaitButtonText = _this$props3.pleaseWaitButtonText,
          submitButtonText = _this$props3.submitButtonText,
          props = _objectWithoutProperties(_this$props3, ["isOpen", "modalTitle", "commentIncluded", "commentPlaceholder", "commentRequired", "commentSubtitle", "highRatingText", "lowRatingText", "onCancel", "onSubmit", "ratingIncluded", "ratingRequired", "ratingSubtitle", "cancelButtonText", "pleaseWaitButtonText", "submitButtonText"]);

      return /*#__PURE__*/React.createElement(Modal, _extends({
        isOpen: isOpen,
        toggle: this.onCancel
      }, props), /*#__PURE__*/React.createElement(ModalHeader, {
        toggle: this.onCancel
      }, modalTitle), /*#__PURE__*/React.createElement(ModalBody, null, this.renderBody()), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(ButtonToolbar, null, /*#__PURE__*/React.createElement(Button, {
        disabled: this.state.submitting,
        color: "primary",
        onClick: this.onSubmit
      }, this.state.submitting ? pleaseWaitButtonText : submitButtonText), /*#__PURE__*/React.createElement(Button, {
        disabled: this.state.submitting,
        onClick: this.onCancel
      }, cancelButtonText))));
    }
  }]);

  return FeedbackModal;
}(Component);

FeedbackModal.propTypes = {
  cancelButtonText: PropTypes.string,
  commentIncluded: PropTypes.bool,
  commentPlaceholder: PropTypes.string,
  commentRequired: PropTypes.bool,
  commentSubtitle: PropTypes.node,
  highRatingText: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  lowRatingText: PropTypes.string,
  modalTitle: PropTypes.node,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  pleaseWaitButtonText: PropTypes.string,
  ratingIncluded: PropTypes.bool,
  ratingRequired: PropTypes.bool,
  ratingSubtitle: PropTypes.node,
  submitButtonText: PropTypes.string
};
FeedbackModal.defaultProps = {
  cancelButtonText: 'Cancel',
  commentIncluded: true,
  commentRequired: true,
  commentSubtitle: 'How could we improve the way this works for you?',
  commentPlaceholder: 'Please give as much detail as you can. Thanks!',
  highRatingText: 'Very satisfied',
  isOpen: false,
  lowRatingText: 'Not satisfied at all',
  modalTitle: 'Give Feedback',
  pleaseWaitButtonText: 'Please Wait...',
  ratingIncluded: true,
  ratingRequired: true,
  ratingSubtitle: 'So far, how satisfied are you with this feature?',
  submitButtonText: 'Send'
};
FeedbackModal.displayName = "FeedbackModal";
export { FeedbackModal as default };